import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/balanceo/auto2.png")